module.exports = __webpack_public_path__ + "img/yinjiang.7cd6bcd9.png";